import { useDrop, useDrag } from '@sketch/modules-common'

export interface DragAndDroppedShareIds {
  draggedShareId: string
  droppedShareId: string
}

export interface DragAndDroppedProjectToShareIds {
  draggedProjectId: string
  droppedShareId: string
}

interface UseShareListItemDragDropProps {
  disabled: boolean
  shareId: string
  onShareDropped?: (args: DragAndDroppedShareIds) => void
  onProjectDropped?: (args: DragAndDroppedProjectToShareIds) => void
}

export const useShareListItemDragDrop = ({
  disabled,
  shareId: droppedShareId,
  onShareDropped,
  onProjectDropped,
}: UseShareListItemDragDropProps) => {
  const dropEvents = useDrop({
    onShareDropped: ({ shareId: draggedShareId }) => {
      onShareDropped?.({ draggedShareId, droppedShareId })
    },
    onProjectDropped: ({ projectId: draggedProjectId }) => {
      onProjectDropped?.({ draggedProjectId, droppedShareId })
    },
  })

  const dragEvents = useDrag({
    type: 'share',
    identifier: droppedShareId,
  })

  return {
    draggable: !disabled,
    ...dragEvents,
    ...dropEvents,
  }
}
